<template>
	<div class="template time">
		<div class="panel_wrap">
			<div class="file-wrap-title">{{dataVal.title}}<span v-show="dataVal.require" class="require">*</span> </div>
			<div class="input_value">
				<el-date-picker v-model="dataVal.value" align="right" style="width: 100%;" type="datetime" placeholder="选择日期时间"></el-date-picker>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		props: ['dataVal'],
		data() {
			return {

			}
		}
	}
</script>

<style>
	@import "../../assets/css/common.css";
	.panel_wrap .el-input__prefix{
		display: none !important;
	}
	.el-input--suffix .el-input__inner{
		padding-right: 0;
	}
</style>
